import { combineReducers } from 'redux';
import authReducer from './auth';
import supportReducer from './support';

const rootReducer = combineReducers({
  authReducer,
  supportReducer,
});

export default rootReducer;
